import Http from './axios-config';

class StaffActivityService {
    constructor() {
        this.http = new Http();
    }

    /**
     * Every staff member with when they were last active: { serverTime, staff: [{ id, name, role,
     * lastSeenAt, online }] }. superAdmin only (403 for anyone else). The Staff activity page asks
     * every 30 seconds and shows its own notice when this fails, so it never toasts.
     * A 401 still goes through the usual refresh / sign-out.
     */
    async getStaffActivity() {
        return await this.http.get('/admins/settings/staff-activity', { silentErrors: true });
    }
}

export default new StaffActivityService();
